import {FFTR} from "kissfft-js";
// import {FFTR} from "./FASTKissFFT";
// import {Int, RealArray, ComplexArray, RealFFTConfig} from "kissfft-wasm";
// import {KissFFTR} from "browser-safe-kissfft";

export const getConstValues = (val: number, numVals: number) => {
    const values = new Float32Array(numVals);
    for (let idx = 0; idx < numVals; idx++) {
        values[idx] = val;
    }
    return values;
}

export const getLinValues = (valRes: number, numVals: number, descending: boolean = false) => {
    const values = new Float32Array(numVals);
    if(descending)
    {
        for (let idx = 0; idx < numVals; idx++) {
            values[(numVals-1) - idx] = idx * valRes;
        }
    }
    else {
        for (let idx = 0; idx < numVals; idx++) {
            values[idx] = idx * valRes;
        }
    }
    return values;
}

export const getFrequencies = (freqRes: number, numFreqs: number, descending: boolean) => {
    return getLinValues(freqRes, numFreqs, descending);
}

export const getTimes = (timeRes: number, numTimes: number, descending: boolean) => {
    return getLinValues(timeRes, numTimes, descending);
}

export const getZeros = (numVals: number) => {
    return getConstValues(0.0, numVals);
}

export class FFTAnalyzer
{
    // fftLength = <Int>2400;
    fftLength = 2400;
    inputData: number[] = [];
    magData = new Float32Array(this.fftLength/2);
    // _fft = new RealFFTConfig(this.fftLength);
    fft = new FFTR(this.fftLength);

    constructor(nfft: number) {
        this.setFFTLength(nfft);
        console.log('FFTAnalyzer.constructor(' + nfft + ')');
    }

    public setFFTLength(nfft: number) {
        if(this.fftLength !== nfft)
        {
            this.fftLength = nfft;
            if(this.fft)
            {
                this.fft.dispose();
            }
            this.fft = new FFTR(this.fftLength);
            this.inputData[this.fftLength-1] = 0;
            this.magData = new Float32Array(this.fftLength/2);
        }
    }

    public computeFFT(inputBuffer: Float32Array): Float32Array
    {
        for (let idx = 0; idx < inputBuffer.length; idx++) {
            this.inputData[idx] = inputBuffer[idx];
        }
        const out = this.fft.forward(this.inputData);
        let jdx = 0;
        for (let idx = 0; idx < this.fftLength / 2; idx++) {
            jdx = 2 * idx;
            this.magData[idx] = 10 * Math.log10((out[jdx] * out[jdx] + out[jdx+1] * out[jdx+1])/this.fftLength);
            if (this.magData[idx] === -Infinity) {
                this.magData[idx] = 0;
            }
        }
        return this.magData;
        // return inputBuffer;
    }
}

